/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Message_LabelInputs */

const en_contact_form_message_label = /** @type {(inputs: Contact_Form_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const lv_contact_form_message_label = /** @type {(inputs: Contact_Form_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziņa`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Contact_Form_Message_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_message_label = /** @type {((inputs?: Contact_Form_Message_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Message_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_message_label(inputs)
	return en_contact_form_message_label(inputs)
});